import { useState, useRef, useEffect } from 'react';
import { Maximize2, Minimize2 } from 'lucide-react';
import './VisorSection.css';

const VisorSection = ({ title, subtitle, iframeSrc }) => {
  const [isFullScreen, setIsFullScreen] = useState(false);
  const iframeRef = useRef(null);

  const toggleFullScreen = () => {
    if (!document.fullscreenElement) {
      iframeRef.current?.requestFullscreen().catch(err => {
        console.error(`Error attempting to enable full-screen mode: ${err.message} (${err.name})`);
      });
      setIsFullScreen(true);
    } else {
      document.exitFullscreen();
      setIsFullScreen(false);
    }
  };
  
  useEffect(() => {
    const handleFullscreenChange = () => {
      setIsFullScreen(!!document.fullscreenElement);
    };
    document.addEventListener('fullscreenchange', handleFullscreenChange);
    return () => document.removeEventListener('fullscreenchange', handleFullscreenChange);
  }, []);

  return (
    <section className="visor-section py-12 md:py-16 bg-white environmental-theme">
      <div className="container mx-auto px-4">
        <div className="text-center mb-8 md:mb-12">
          <h2 className="text-3xl md:text-4xl font-bold text-[var(--text-primary)] mb-2">{title}</h2>
          {subtitle && <p className="text-lg text-[var(--text-secondary)]">{subtitle}</p>}
        </div>
        <div className="relative border border-gray-300 rounded-lg shadow-lg overflow-hidden aspect-[16/9] max-h-[70vh]">
          <iframe
            ref={iframeRef}
            src={iframeSrc}
            title={title}
            className="w-full h-full"
            frameBorder="0"
            allowFullScreen
          ></iframe>
          <button 
            onClick={toggleFullScreen}
            className="absolute top-2 right-2 bg-gray-800 text-white p-2 rounded-full opacity-70 hover:opacity-100 transition-opacity z-10"
            title={isFullScreen ? "Salir de pantalla completa" : "Ver en pantalla completa"}
          >
            {isFullScreen ? <Minimize2 size={20} /> : <Maximize2 size={20} />}
          </button>
        </div>
      </div>
    </section>
  );
};

export default VisorSection;